import { render, staticRenderFns } from "./shopSetting.vue?vue&type=template&id=fad7cca0&scoped=true"
import script from "./shopSetting.vue?vue&type=script&lang=js"
export * from "./shopSetting.vue?vue&type=script&lang=js"
import style0 from "./shopSetting.vue?vue&type=style&index=0&id=fad7cca0&scoped=true&lang=scss"
import style1 from "./shopSetting.vue?vue&type=style&index=1&id=fad7cca0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad7cca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fad7cca0')) {
      api.createRecord('fad7cca0', component.options)
    } else {
      api.reload('fad7cca0', component.options)
    }
    module.hot.accept("./shopSetting.vue?vue&type=template&id=fad7cca0&scoped=true", function () {
      api.rerender('fad7cca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/shopSetting/shopSetting.vue"
export default component.exports